/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableHeader,
  TableSelectRow,
  TableToolbar,
  TableBatchActions,
  TableBatchAction,
  Loading,
  Button,
  Pagination,
} from 'carbon-components-react';
import PropTypes, { number } from 'prop-types';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Error16 from '@carbon/icons-react/lib/error/16';
import Send16 from '@carbon/icons-react/lib/send/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Task16 from '@carbon/icons-react/lib/task/16';
import View16 from '@carbon/icons-react/lib/view/16';
import ExportDoc16 from '@carbon/icons-react/lib/document--export/16';
import CheckmarkOutline16 from '@carbon/icons-react/lib/checkmark--outline/16';
import SimpleReactValidator from 'simple-react-validator';
import { Link } from 'react-router-dom';
import { api, me } from '../../helpers/api/api';
import { WFActionModal } from '../common/WFActionModal';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { CanExecuteAction, IsInRole } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import {
  getError,
  STATUS,
  getSuccess,
  apioperation,
  entitiesLabels,
} from '../../helpers/Constants';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { StatusTag } from '../../helpers/PageBreadCrumb';
import { Online, Offline } from '../common/OnLineOffLine';
import ConfirmModal from '../common/ConfirmModal';

export default class EDrillMultiSelectDataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      isLoadingNotificationFile: false,
      filteredEDrills: null, // props.allYearEDrills,
      showFilters: false,
      // filteredMonth: null,
      selectedApprover: {},
      modalDeleteVisible: false,
      modalSubmitVisible: false,
      isSubmitted: false,
      isModifiedPlannedWeekApprovalModalOpen: false,
      modifiedPlannedWeekApprovalModalMessage: ''
    };

    // this.onSelectEDrillTypeChange = this.onSelectEDrillTypeChange.bind(this);
    // this.onSelectStatusChange = this.onSelectStatusChange.bind(this);
    // this.onSelectWorkSiteChange = this.onSelectWorkSiteChange.bind(this);
    // this.onSelectTargetChange = this.onSelectTargetChange.bind(this);
    // this.onSelectScopeChange = this.onSelectScopeChange.bind(this);
    this.onSelectDataApproverChange = this.onSelectDataApproverChange.bind(this);
    this.renderLoadingModal = this.renderLoadingModal.bind(this);
    // this.handleClickCancelSearch = this.handleClickCancelSearch.bind(this);
    this.handleClickSearch = this.handleClickSearch.bind(this);
    this.validator = new SimpleReactValidator();
    this.handleChangePaging = this.handleChangePaging.bind(this);

    this.filters = {};
    this.textInput = React.createRef();

    this.validations = {
      dataApprover: this.validator.message(
        'dataApprover',
        this.state.selectedApprover.id,
        'required'
      ),
    };
  }

  // static getDerivedStateFromProps(props, state) {
    // Any time the current user changes,
    // Reset any parts of state that are tied to that user.
    // In this simple example, that's just the email.
  //   if (props.allYearEDrills !== state.filteredEDrills) {
  //     return {
  //       filteredEDrills: props.allYearEDrills,
  //     };
  //   }
  //   return null;
  // }

  // toogleCalendar = (e) => {
  //   this.props.toogleCalendar(e);
  // };

  // onSelectEDrillTypeChange = (selectedItem) => {
  //   this.props.onTypeFilter(selectedItem);
  // };

  // onSelectScopeChange = (selectedItem) => {
  //   this.props.onScopeFilter(selectedItem);
  // };

  // onSelectTargetChange = (selectedItem) => {
  //   this.props.onTargetFilter(selectedItem);
  // };

  // onSelectStatusChange = (selectedItem) => {
  //   this.props.onStatusFilter(selectedItem);
  // };

  // onSelectWorkSiteChange = (selectedItem) => {
  //   this.props.onWorkSiteFilter(selectedItem);
  // };

  getUsersInRole = (role, appModule, idWorksite, idDivision) => { //RITM1064131
    me.getWithParam('getuserbyroleandmodule', { //RITM1064131
      params: { Role: role, appModule: appModule, idWorksites: idWorksite, IdDivision: idDivision, includeAdmins: true }, //RITM1064131
    })
      .then((response) => {
        this.setState({
          approvers: response.data,
          isLoadingApproverOptions: false,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, '', 'ERROR'));
      })
      .finally(() => {
        this.setState({
          isLoadingApproverOptions: false,
        });
      });
  };

  // eslint-disable-next-line react/sort-comp
  IsRowSelectable(tableRow, selectedRows, user) {
    const row = this.props.eDrills.find((i) => i.id === tableRow.id);

    if (!row || !row.status) return false;

    if (row.idStatus === 4 &&
      row.drillModifiedPlannedWeekSets?.length > 0 &&
      row.drillModifiedPlannedWeekSets[0].idDataApprover === user.id) return true;

    if (row.isInReport === true) return false;

    if (
      row.idStatus === 4 &&
      row.isInReport === false &&
      (IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver')) //RITM1064131
    ) return true;

    const canSelect =
      CanExecuteAction('Emergency Drill', 'Planning', user, row.idStatus, 'Submit', row) ||
      CanExecuteAction('Emergency Drill', 'Planning', user, row.idStatus, 'Approve', row) ||
      CanExecuteAction('Emergency Drill', 'Planning', user, row.idStatus, 'Reject', row) ||
      CanExecuteAction('Emergency Drill', 'Planning', user, row.idStatus, 'Delete', row);

    if (selectedRows.length === 0) {
      return canSelect;
    }

    if (selectedRows.length > 0) {
      const selectableEDrill = this.props.eDrills.find((i) => i.id === selectedRows[0].id);
      const selectableState = selectableEDrill.idStatus;
      const selectableDivision =
        selectableEDrill.division == null
          ? selectableEDrill?.workSite?.idDivision
          : selectableEDrill.division?.id;
      const selectableWorksite = selectableEDrill.idWorkSite;

      if (
        row.idStatus === selectableState &&
        ((row.idStatus === STATUS.Draft && row.idWorkSite === selectableWorksite) ||
        (row.idStatus !== STATUS.Draft && row.division == null && row?.workSite?.idDivision) ||
        (row.idStatus !== STATUS.Draft && row.division != null && 
          row.division?.id === selectableDivision))
      ) {
        return canSelect;
      }

      return false;
    }

    return false;
  }

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows
  ) {
    const eDrill = this.props.eDrills.find((i) => i.id === selectedRows[0].id);

    const idWorksite = eDrill.idWorkSite; //RITM1064131
		const idDivision = eDrill.workSite?.idDivision; //RITM1064131


    this.setState({
      approvalModalAction: actionName,
      isApprovalModalOpen: true,
      isLoadingApproverOptions: true,
      withApprover,
      selectedData: selectedRows,
      approverRole,
      approvalEndpoint: actionKey,
      approvalNotesRequired,
    });

    if (withApprover) this.getUsersInRole(approverRole, 'Emergency Drill', idWorksite, idDivision); //RITM1064131
  }

  onBatchClick(
    title,
    message,
    actionKey,
    selectedRows
  ) {
    this.setState(() => ({
      isModifiedPlannedWeekApprovalModalOpen: true,
      approvalEndpoint: actionKey,
      approvalModalAction: title,
      modifiedPlannedWeekApprovalModalMessage: message,
      selectedData: selectedRows
    }));
  }

  toogleFilterModal = (e) => {
    this.props.toogleFilterModal(e);
  };

  handleChangePaging = (event) => {
    this.props.handleChangePaging(event);
  };

  onSelectDataApproverChange = (selectedItem) => {
    this.setState({
      selectedApprover: selectedItem || {},
    });
  };

  buildNoMonthFilter = () => {
    let { filteredEDrills } = this.state;
    filteredEDrills = this.state.filteredDivision
      ? filteredEDrills.filter((item) => item.idDivision === this.state.filteredDivision)
      : filteredEDrills;
    return filteredEDrills;
  };

  /* onMonthFilter = (event) => {
    this.setState({
      filteredMonth: event.currentTarget.id > 0 ? parseInt(event.currentTarget.id, 10) : null,
      filteredEDrills: this.buildNoMonthFilter(),
    });
    this.props.onMonthFilter(
      event.currentTarget.id > 0 ? parseInt(event.currentTarget.id, 10) : null
    );
  }; */

  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleCloseModifiedPlannedWeekApprovalModal = () => {
    this.setState(() => ({ isModifiedPlannedWeekApprovalModalOpen: false,
      approvalEndpoint: '',
      approvalModalAction: '',
      modifiedPlannedWeekApprovalModalMessage: '',
      selectedData: null }));
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    const apiEndpoint = this.state.approvalEndpoint;
    const data = {
      ids: this.state.selectedData.map((r) => r.id),
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.props.onWaitingSubmit();
    api
      .put(`/drill/${apiEndpoint}`, data, '')
      .then((response) => {
        this.props.onWaitingSubmit();
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL, apioperation.PUT));
          this.setState({
            isApprovalModalOpen: false,
            // isLoading: true,
            // itemList: []
          });
          this.props.onRefreshData();
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        this.props.onWaitingSubmit();
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, error.response.data, 'ERROR'));
      })
      .finally(() => {});
  };

  handleConfirmModifiedPlannedWeekApprovalModal = () => {
    const apiEndpoint = this.state.approvalEndpoint;
    const data = {
      Ids: this.state.selectedData.map(
        (r) => this.props.eDrills.find((i) => i.id === r.id)?.drillModifiedPlannedWeekSets[0].id)
    };

    this.props.onWaitingSubmit();
    api
      .put(`/drill/${apiEndpoint}`, data, '')
      .then((response) => {
        this.props.onWaitingSubmit();
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`, `${entitiesLabels.EMERGENCYDRILL_PLANNEDWEEKCHANGES} correctly managed`);
          this.setState(() => ({ isModifiedPlannedWeekApprovalModalOpen: false }));
          this.props.onRefreshData();
        } else {
          const message = response.data || '';
          if (response.status === 501) showNotification.error(`${entitiesLabels.ERROR}`, `${entitiesLabels.EMERGENCYDRILL_PLANNEDWEEKCHANGES} ${message}`);
          else {
            const error = { response };
            showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL_PLANNEDWEEKCHANGES, apioperation.PUT));
          }
        }
      })
      .catch((error) => {
        this.props.onWaitingSubmit();
        if (error.response) {
          const message = error.response.data || '';
          if (error.response.status === 501) showNotification.error(`${entitiesLabels.ERROR}`, `${entitiesLabels.EMERGENCYDRILL_PLANNEDWEEKCHANGES} ${message}`);
          else showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL_PLANNEDWEEKCHANGES, apioperation.PUT));
        }
      });
  };
  /** ***********Render******************* */

  getEDrill = (selectedRows) => {
    if (selectedRows && selectedRows.length > 0) {
      return this.props.eDrills.find((el) => el.id === selectedRows[0].id);
    }
    return null;
  };

  getEDrillor = (selectedRows) => {
    if (selectedRows && selectedRows.length > 0) {
      const au = this.props.eDrills.find((el) => el.id === selectedRows[0].id);
      return au && au.eDrillors && au.eDrillors[0] ? { idCompiler: au.eDrillors[0].id } : null;
    }
    return null;
  };

  getEDrillReport = (selectedRows) => {
    if (selectedRows && selectedRows.length > 0) {
      const r = this.props.eDrills.find((el) => el.id === selectedRows[0].id);
      return r && r.checkList;
    }
    return null;
  };

  getStatusId = (idRow) => {
    const r = this.props.eDrills.find((el) => el.id === idRow);
    return r && r.idStatus;
  };

  getIsInReport = (idRow) => {
    const r = this.props.eDrills.find((el) => el.id === idRow);
    if (r.isInReport === false) return true;
    return false;
  };

  getReportStatusId = (idRow) => {
    const r = this.props.eDrills.find((el) => el.id === idRow);
    return r && r.checkList;
  };

  getIsModificationWeeksDataApprover = (idRow, user) => {
    const r = this.props.eDrills.find((el) => el.id === idRow);
    if (r && r.idStatus > STATUS.Approved && r.drillModifiedPlannedWeekSets?.length > 0 &&
      r.drillModifiedPlannedWeekSets[0].idDataApprover === user.id) return true;
    return false;
  };

  canViewReports = (idRow) => {
    const r = this.props.eDrills.find((el) => el.id === idRow);
    if (r && r.idStatus > STATUS.Approved && r.isInReport === true) return true;
    return false;
  };

  renderLoadingModal = () => {
    const show = this.state.isSubmitted;
    return show && <Loading active withOverlay description="Saving..." />;
  };

  renderDeleteModal = (totalItems) =>
  this.state.modalDeleteVisible && (
    <div className="bx--modal bx--modal-tall is-visible">
      <div className="bx--modal-container">
        <div className="bx--modal-header">
          <h3 className="bx--modal-header__heading"> Delete draft eDrills</h3>
          <Button
            className="bx--modal-close"
            renderIcon={Close16}
            onClick={this.handleDeleteClose}
          />
        </div>

        <div className="bx--modal-content">
          <div className="bx--row" />
          <div className="bx--col-lg-12 bx--col-md-12">
            <h4 className="align-center">
              Press confirm to delete
              {` ${totalItems} `}
              eDrill/s selected
            </h4>
          </div>
        </div>
        <div className="bx--modal-footer">
          <Button className="button--max-width" kind="secondary" onClick={this.handleDeleteClose}>
            Cancel
          </Button>
          <Button className="button--max-width" kind="primary" onClick={this.handleDeleteSubmit}>
            Confirm
          </Button>
        </div>
      </div>
    </div>
  );

  renderSubmitModal = (totalItems) => 
  // const validations = {
  //   dataApprover: this.validator.message(
  //     'dataApprover',
  //     this.state.selectedApprover.id,
  //     'required'
  //   ),
  // };
   (
    this.state.modalSubmitVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading">Submit Drill</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleStatusSubmitClose}
            />
          </div>

          <div className="bx--modal-content bx-modal-content-detail">
            <div className="bx--row" />
            <div className="bx--col-lg-12 bx--col-md-12">
              <h5 className="align-center">
                Choose a Data Approver and than confirm to submit
                {` ${totalItems} `}
                Drill/s selected
              </h5>
            </div>
            <div className="bx--row" />
          </div>
          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleStatusSubmitClose}
            >
              Cancel
            </Button>
            <Button
              className="button--max-width"
              kind="primary"
              onClick={this.handleStatusSubmit}
            >
              Confirm
            </Button>
          </div>
        </div>
      </div>
    )
  )
;

  /* renderMonthsHeader = () => {
    const elements = [
      'All',
      'Gen',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const items = elements.map((item, index) => (
      // eslint-disable-next-line jsx-a11y/interactive-supports-focus
      <div
        focusable="true"
        onClick={this.onMonthFilter}
        className={` bx--col bx--header-orientation header-calendar row-description-calendar  ${
          (!this.state.filteredMonth && index === 0) || this.state.filteredMonth === index
            ? 'bx--header-orientation-current'
            : ''
        }`}
        id={index}
        key={`monthHead-${item}`}
        role="button"
      >
        <div className="detail">{item}</div>

        <div className="information-number number">
          {index > 0
            ? this.state.filteredEDrills.filter((elem) => elem.referenceMonth === index).length
            : this.state.filteredEDrills.length}
        </div>
      </div>
    ));

    return <div className="bx--row description-header ">{items}</div>;
  }; */

  getCellValue = (type, value,) => {
    if (!value) return '';
    if (typeof value === 'object') {
      if (type.header.includes('eDrillor')) {
        return value.fullName;
      }
      if (type.header.includes('status')) {
        return <StatusTag value={`drill${value.planningName}`} />;
      }
      if (type.header.includes('checkList')) {
        return <StatusTag value={value.status.reportingName} />;
      }

      if (value instanceof Array) {
        return value.map((elem) => elem.name).join(', ');
      }
      return value.name;
    }
    if (type.header.includes('Month')) {
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      const monthToString = (monthNumber) => months[monthNumber - 1] || '';
      return monthToString(value);
    }
    return value;
  };

  // handleClickCancelSearch = () => {
  //   this.textInput.current.value = '';
  //   for (const prop in this.filters) {
  //     if (Object.prototype.hasOwnProperty.call(this.filters, prop)) {
  //       this.filters[prop] = Array.isArray(this.filters[prop]) ? [] : null;
  //     }
  //   }
  //   this.props.applyFilters(this.filters, false);
  // };

  handleClickSearch = () => {
    this.props.applyFilters(this.filters, true);
  };

  DownloadEDrillReport(eDrillId) {
    this.setState({ isLoadingNotificationFile: true });
    api
      .getWithParam(`/eDrill/${eDrillId}/exportreport`, { responseType: 'arraybuffer' })
      .then((response) => {
        const data = new Blob([response.data], { type: 'application/pdf' });
        const csvURL = window.URL.createObjectURL(data);
        const tempLink = document.createElement('a');
        tempLink.href = csvURL;
        const eDrillCode = this.props.eDrills.find((i) => i.id === eDrillId);
        const nomefile = `EDrill_Report_${eDrillCode.eDrillCode}.pdf`;
        tempLink.setAttribute('download', nomefile);
        document.body.appendChild(tempLink);
        tempLink.click();
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.EMERGENCYDRILL_REPORT, apioperation.DOWNLOAD)
        );
        // console.log(eDrillId);
      })
      .finally(() => {
        this.setState({ isLoadingNotificationFile: false });
      });
  }

  DownloadEDrillNotification(eDrillId) {
    this.setState({ isLoadingNotificationFile: true });
    api
      .getWithParam(`/eDrill/${eDrillId}/export`, { responseType: 'arraybuffer' })
      .then((response) => {
        const data = new Blob([response.data], { type: 'application/pdf' });
        const csvURL = window.URL.createObjectURL(data);
        const tempLink = document.createElement('a');
        tempLink.href = csvURL;
        const eDrillCode = this.props.eDrills.find((i) => i.id === eDrillId);
        const nomefile = `EDrill_Notification_${eDrillCode.eDrillCode}.pdf`;
        tempLink.setAttribute('download', nomefile);
        document.body.appendChild(tempLink);
        tempLink.click();
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.EMERGENCYDRILL_NOTIFICATION, apioperation.DOWNLOAD)
        );
        // console.log(eDrillId);
      })
      .finally(() => {
        this.setState({ isLoadingNotificationFile: false });
      });
  }

  showFilters() {
    this.setState((oldState) => ({ showFilters: !oldState.showFilters }));
  }

  // renderFilters = () => (
  //   <div style={{ display: this.state.showFilters ? 'block' : 'none' }}>
  //     <div className="bx--row">

  //       <FormGroup className="bx--col-lg-6 bx--col-md-4">
  //         <FormLabel>Company</FormLabel>
  //         <Combo
  //           url="me/companies"
  //           onChange={event =>
  //             this.filters['company'] = event.selectedItem
  //           }
  //           onError={(error) => { }}
  //           disabled={false}
  //           initialSelectedItems={this.filters['company']}
  //         />
  //       </FormGroup>

  //       <FormGroup className="bx--col-lg-6 bx--col-md-4">
  //         <FormLabel>Worksite</FormLabel>
  //         <Combo
  //           url="me/workSites"
  //           onChange={event =>
  //             this.filters['workSite'] = event.selectedItem
  //           }
  //           onError={(error) => { }}
  //           disabled={false}
  //           initialSelectedItems={this.filters['workSite']}
  //         />
  //       </FormGroup>

  //       <FormGroup className="bx--col-lg-4 bx--col-md-4">
  //         <FormLabel>Drill Code</FormLabel>
  //         <TextInput
  //           id="drillCode"
  //           name="drillCode"
  //           onChange={event =>
  //             this.filters['drillCode'] = event.target.value
  //           }
  //           type="text"
  //           ref={this.textInput}
  //         />
  //       </FormGroup>

  //       {/*<FormGroup className="bx--col-lg-6 bx--col-md-4">
  //                   <FormLabel>Projects</FormLabel>
  //                 <Combo
  //                     multiCombo={true}
  //                     url="me/project"
  //                     onChange={prjs =>
  //                         this.filters['projects'] = prjs
  //                     }
  //                     onError={(error) => { }}
  //                     initialSelectedItems={this.filters['projects'] || []}
  //                     disabled={false}
  //                 />
  //               </FormGroup> */}

  //       <FormGroup className="bx--col-lg-4 bx--col-md-4">
  //         <FormLabel>Drill Type</FormLabel>
  //         <Combo
  //           url="drill/drilltype"
  //           onChange={event =>
  //             this.filters['drillType'] = event.selectedItem
  //           }
  //           onError={(error) => { }}
  //           loadAll
  //           disabled={false}
  //           initialSelectedItems={this.filters['drillType']}
  //         />
  //       </FormGroup>

  //       <FormGroup className="bx--col-lg-4 bx--col-md-4">
  //         <FormLabel>Drill Type Detail</FormLabel>
  //         <Combo
  //           url="drill/drilltype/drilltypedetails"
  //           onChange={event =>
  //             this.filters['drillTypeDetail'] = event.selectedItem
  //           }
  //           onError={(error) => { }}
  //           loadAll
  //           disabled={false}
  //           initialSelectedItems={this.filters['drillTypeDetail']}
  //         />
  //       </FormGroup>

  //     </div>

  //     <div className="searchFormFooter">
  //       <Button className="button--max-width" 
  //               size="small" 
  //               kind="secondary" 
  //               onClick={this.handleClickCancelSearch} >Cancel</Button>
  //       <Button className="button--max-width" 
  //               size="small" 
  //               onClick={this.handleClickSearch} >Search</Button>
  //     </div>
  //   </div>
  // );

  render() {
    const headers = [
      {
        key: 'drillCode',
        header: 'Drill Code',
      },
      {
        key: 'division',
        //RITM0945977
        // header: 'Division',
        header: 'Business Line',
      },
      {
        key: 'company',
        header: 'Company',
      },
      {
        key: 'workSite',
        header: 'WorkSite',
      },
      {
        key: 'participant',
        header: 'Participant',
      },
      {
        key: 'frequency',
        header: 'Frequency',
      },
      {
        key: 'drillType',
        header: 'Drill Type',
      },
      {
        key: 'drillTypeDetail',
        header: 'Drill Type Detail',
      },
      {
        key: 'status',
        header: 'Status',
      },
    ];
    const paginationProps = () => ({
      page: this.props.paginationInfo.currentPage || 1,
      totalItems: this.props.paginationInfo.rowCount || 0,
      pageSize: this.props.paginationInfo.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.handleChangePaging,
    });

    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <Loading active={this.state.isLoadingNotificationFile} withOverlay />
            <DataTable
              useZebraStyles="true"
              rows={this.props.eDrills}
              headers={headers}
              render={({
                rows,
                getHeaderProps,
                getSelectionProps,
                getBatchActionProps,
                selectedRows,
              }) => (
                <TableContainer>
                  {selectedRows.length > 0 ? (
                    <TableToolbar>
                      <Online>
                        <TableBatchActions {...getBatchActionProps()}>
                          {CanExecuteAction(
                            'Emergency Drill',
                            'Planning',
                            user,
                            selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
                            'Submit',
                            this.getEDrill(selectedRows)
                          ) ? (
                            <TableBatchAction
                              renderIcon={Send16}
                              onClick={() =>
                                this.batchActionClick(
                                  'Submit',
                                  'Submit',
                                  'Data Approver',
                                  true,
                                  false,
                                  selectedRows
                                )
                              }
                            >
                              Submit Plan
                            </TableBatchAction>
                          ) : null}

                          {CanExecuteAction(
                            'Emergency Drill',
                            'Planning',
                            user,
                            selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
                            'Approve',
                            this.getEDrill(selectedRows)
                          ) ? (
                            <TableBatchAction
                              renderIcon={CheckmarkOutline16}
                              onClick={() =>
                                this.batchActionClick(
                                  'Approve',
                                  'Approve',
                                  null,
                                  false,
                                  false,
                                  selectedRows
                                )
                              }
                            >
                              Approve Plan
                            </TableBatchAction>
                          ) : null}

                          {CanExecuteAction(
                            'Emergency Drill',
                            'Planning',
                            user,
                            selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
                            'Reject',
                            this.getEDrill(selectedRows)
                          ) ? (
                            <TableBatchAction
                              renderIcon={Error16}
                              onClick={() =>
                                this.batchActionClick(
                                  'Reject',
                                  'Reject',
                                  null,
                                  false,
                                  true,
                                  selectedRows
                                )
                              }
                            >
                              Reject Plan
                            </TableBatchAction>
                          ) : null}

                          {CanExecuteAction(
                            'Emergency Drill',
                            'Planning',
                            user,
                            selectedRows.length > 0 ? this.getStatusId(selectedRows[0].id) : null,
                            'Delete',
                            this.getEDrill(selectedRows)
                          ) ? (
                            <TableBatchAction
                              renderIcon={Delete16}
                              onClick={() =>
                                this.batchActionClick(
                                  'Delete',
                                  'Delete',
                                  null,
                                  false,
                                  false,
                                  selectedRows
                                )
                              }
                            >
                              Delete Plan
                            </TableBatchAction>
                          ) : null}
                          {selectedRows.length > 0 &&
                            this.getStatusId(selectedRows[0].id) === 4 &&
                            this.getIsInReport(selectedRows[0].id) && (
                              <>
                                {IsInRole(user, 'Administrator') || IsInRole(user, 'Compiler') || IsInRole(user, 'Data Approver') ? ( //RITM1064131
                                  <TableBatchAction
                                    renderIcon={Task16}
                                    onClick={() =>
                                      this.batchActionClick(
                                        'newreport',
                                        'Assign',
                                        null,
                                        false,
                                        false,
                                        selectedRows
                                      )
                                    }
                                  >
                                    Assign Report
                                  </TableBatchAction>
                                ) : null}
                              </>
                            )}
                          {selectedRows.length > 0 &&
                            this.getStatusId(selectedRows[0].id) === 4 &&
                            this.getIsModificationWeeksDataApprover(selectedRows[0].id, user) && (
                            <>
                              <TableBatchAction
                                renderIcon={Task16}
                                onClick={() =>
                                  this.onBatchClick(
                                    'Confirm modifications',
                                    'Confirm the modifications of the selected Drill plan?',
                                    'confirmdrillmodifiedplannedweekset',
                                    selectedRows
                                  )
                                }
                              >
                                Confirm Modification Request
                              </TableBatchAction>
                              <TableBatchAction
                                renderIcon={Error16}
                                onClick={() =>
                                  this.onBatchClick(
                                    'Decline modifications',
                                    'Decline the modifications of the selected Drill plan?',
                                    'declinedrillmodifiedplannedweekset',
                                    selectedRows
                                  )
                                }
                              >
                                Decline Modification Request
                              </TableBatchAction>
                            </>
                          )}
                        </TableBatchActions>
                      </Online>
                    </TableToolbar>
                  ) : (
                    ''
                  )}

                  {/* {this.renderFilters()} */}

                  <WFActionModal
                    show={this.state.isApprovalModalOpen}
                    title={`${this.state.approvalModalAction} Drills`}
                    action={this.state.approvalModalAction}
                    withApprover={this.state.withApprover}
                    approver={this.state.approver}
                    approverRole={this.state.approverRole}
                    approverOptions={this.state.approvers}
                    isLoadingOperation={this.state.isLoadingWFOperation}
                    onApproverSelect={this.handleApproverSelect}
                    isLoadingOptions={this.state.isLoadingApproverOptions}
                    onCancel={this.handleCloseApprovalModal}
                    onConfirm={this.handleConfirmApprovalModal}
                    onApprovalNotesChange={this.handleApprovalNotesChange}
                    approvalNotes={this.state.approvalNotes}
                    approvalNotesRequired={this.state.approvalNotesRequired}
                    validationMessages={this.state.approvalValidationMessages}
                    user={user} //RITM1064131
                  />

                  <ConfirmModal
                    show={this.state.isModifiedPlannedWeekApprovalModalOpen}
                    onClose={this.handleCloseModifiedPlannedWeekApprovalModal}
                    onConfirm={this.handleConfirmModifiedPlannedWeekApprovalModal}
                    title={this.state.approvalModalAction}
                    contentMessage={this.state.modifiedPlannedWeekApprovalModalMessage}
                    confirmBtnText="Confirm"
                  />

                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableHeader className="align-center" />
                        {headers.map((header) => (
                          <TableHeader {...getHeaderProps({ header })}>{header.header}</TableHeader>
                        ))}
                        <TableHeader className="align-center">Actions</TableHeader>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows == null || rows.length === 0 ? (
                        <NoRecordsPlaceholder colSpan={headers.length + 2} />
                      ) : (
                        rows.map((row) => (
                          <TableRow key={row.id}>
                            {this.IsRowSelectable(row, selectedRows, user) ? (
                              <>
                                <Online>
                                  <TableSelectRow {...getSelectionProps({ row })} />
                                </Online>
                                <Offline>
                                  <TableSelectRow {...getSelectionProps({ row })} disabled />
                                </Offline>
                              </>
                            ) : (
                              <TableCell
                                key={`empty${row.id}`}
                                className="tableActions align-center"
                              />
                            )}
                            {row.cells.map((cell) => (
                              <TableCell key={cell.id}>
                                {this.getCellValue(cell.info, cell.value, row.id)}
                              </TableCell>
                            ))}
                            <TableCell
                              key={`action-${row.id}`}
                              className="tableActions align-center"
                            >
                              <div>
                                {this.getReportStatusId(row.id) && (
                                  <Button
                                    size="small"
                                    className="bx--export-form"
                                    renderIcon={ExportDoc16}
                                    iconDescription="Download Notification"
                                    title="Download Notification"
                                    kind="ghost"
                                    onClick={() => this.DownloadEDrillNotification(row.id)}
                                  />
                                )}
                                {this.getReportStatusId(row.id) && (
                                  <Button
                                    size="small"
                                    className=" bx--export-tab-form"
                                    renderIcon={ExportDoc16}
                                    iconDescription="Download Report"
                                    title="Download Report"
                                    kind="ghost"
                                    onClick={() => this.DownloadEDrillReport(row.id)}
                                  />
                                )}
                                {(this.getReportStatusId(row.id) == null ||
                                  IsInRole(user, 'Administrator')) && (
                                  <Button
                                    onClick={() => this.props.onEditEDrill(row)}
                                    size="small"
                                    renderIcon={Edit16}
                                    title="Edit Drill Plan"
                                    iconDescription="Edit Drill Plan"
                                    kind="ghost"
                                  />
                                )}
                                {this.canViewReports(row.id) ? (
                                  <Link to={`/drill/${row.id}/reports`}>
                                    <Button
                                      size="small"
                                      renderIcon={View16}
                                      title="View Drill Reports"
                                      iconDescription="View Drill Reports"
                                      kind="ghost"
                                    />
                                  </Link>
                                ) : (
                                  ''
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            />

            <div className="footer-pagination">
              <Pagination {...paginationProps()} />
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}

EDrillMultiSelectDataTable.propTypes = {
  eDrills: PropTypes.array.isRequired,
  onNewEDrill: PropTypes.func.isRequired,
  onEditEDrill: PropTypes.func.isRequired,
  applyFilters: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
  handleChangePaging: PropTypes.func.isRequired,
  toogleFilterModal: PropTypes.func.isRequired,
  onWaitingSubmit: PropTypes.func.isRequired,
  paginationInfo: PropTypes.shape({
    currentPage: number,
    pageSize: number,
    rowCount: number
  })
};

EDrillMultiSelectDataTable.defaultProps = {
  paginationInfo: {
    currentPage: 1,
    pageSize: 10
  }
};
